import getters from '../../../modules/contracts/src/store/modules/contacts/getters';

export default getters;
